import { Component, Directive, EventEmitter, InjectionToken, Input, Output } from '@angular/core';

/**
 * Lightweight no-op replacement for the deprecated `ngx-perfect-scrollbar` package.
 * Provides both:
 *  - the `[perfectScrollbar]` attribute directive
 *  - the `<perfect-scrollbar>` element component
 *
 * Inputs/outputs match the public surface of the original library so existing
 * templates keep compiling. Scrolling falls back to native CSS overflow.
 */
@Directive({
    standalone: false,
    selector: '[perfectScrollbar]'
})
export class PerfectScrollbarStubDirective {
    @Input('perfectScrollbar') config: any;
    @Input() disabled: boolean;
}

@Component({
    standalone: false,
    selector: 'perfect-scrollbar',
    template: `<ng-content></ng-content>`,
    styles: [':host { display: block; overflow: auto; }']
})
export class PerfectScrollbarStubComponent {
    @Input() config: any;
    @Input() disabled: boolean;
    @Input() usePSClass: any;
    @Input() autoPropagation: any;
    @Input() scrollIndicators: any;

    @Output() psScrollY = new EventEmitter<any>();
    @Output() psScrollX = new EventEmitter<any>();
    @Output() psScrollUp = new EventEmitter<any>();
    @Output() psScrollDown = new EventEmitter<any>();
    @Output() psScrollLeft = new EventEmitter<any>();
    @Output() psScrollRight = new EventEmitter<any>();
    @Output() psYReachStart = new EventEmitter<any>();
    @Output() psYReachEnd = new EventEmitter<any>();
    @Output() psXReachStart = new EventEmitter<any>();
    @Output() psXReachEnd = new EventEmitter<any>();

    scrollToTop(_offset?: number, _speed?: number): void {}
    scrollToBottom(_offset?: number, _speed?: number): void {}
    scrollToLeft(_offset?: number, _speed?: number): void {}
    scrollToRight(_offset?: number, _speed?: number): void {}
    scrollToElement(_qs: string, _offset?: number, _speed?: number): void {}
    update(): void {}
}

export interface PerfectScrollbarConfigInterface {
    [key: string]: any;
}

/** Same role as ngx-perfect-scrollbar's config token; must be an `InjectionToken` for DI. */
export const PERFECT_SCROLLBAR_CONFIG = new InjectionToken<PerfectScrollbarConfigInterface>(
    'PERFECT_SCROLLBAR_CONFIG'
);
